<template>
    <section class="flex md:flex-col">
        <section>
            <AdminDashboardNav/>
        </section>
        <section class="font-poppins w-screen p-2 md:p-1 md:pr-1">    
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-sm">MANAGE USERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>

            <div class="flex mt-8 md:text-sm">
                <div @click="goBack" class="flex cursor-pointer">
                    <i class="fa fa-arrow-left mr-3"></i>
                    <p >Go Back</p>
                </div>
                <div class="ml-6">
                    <p>User Information</p>
                </div>
            </div>

            <section>
                

                <div>
                    <InfoDetails :id="id"/>
                </div>
            </section>
        </section>
    </section>
</template>

<script>
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue'
import InfoDetails from './InfoDetails.vue';

export default {
    props: ['id'],
    components : {
        AdminDashboardNav,
        GetDate,
        Notification,
        InfoDetails
    },
    data() {
        return {
            
        }
    },

    mounted() {
        this.networkError()
    },

    methods: {
        goBack() {
           this.$router.go(-1)
        },
        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>